import { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import queryString from 'query-string';
import copy from 'copy-to-clipboard';
import { useNavigate } from 'react-router-dom';
import { ButtonPrimary, ButtonPseudo } from '@ui/src';
import { useAppDispatch } from '@store';
import { clearMfa, setTotpNotActive } from '../../hoc/store/slice';
import { SetupTwoFactorFormTypes } from './types';

import ROUTES from '../../routes';

import cn from './styles.module.css';
import sharedStyles from '../shared.module.css';

const SetupTwoFactorForm = ({ totpUri }: SetupTwoFactorFormTypes) => {
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);
  const [totpSecretKey, setTotpSecretKey] = useState('');

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const onCopy = () => {
    copy(totpSecretKey);

    setCopyIsSuccess(true);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  useEffect(() => {
    if (totpUri) {
      const parsedTotpUri = queryString.parse(totpUri);

      if (parsedTotpUri) {
        setTotpSecretKey(parsedTotpUri.secret as string);
      }
    }
  }, [totpUri]);

  return (
    <div className={sharedStyles.form}>
      <div className={cn.setupTwoFactorTitle}>
        Scan the QR code into your authenticator app
      </div>
      <div className={cn.qrWrapper}>
        <QRCode size={87} value={totpUri as string} viewBox="0 0 87 87" />
      </div>
      <div className={cn.setupTwoFactorHint}>
        or type the text code into your app:
      </div>
      <button
        type="button"
        className={cn.setupTwoFactorButton}
        onClick={onCopy}
      >
        <div>{totpSecretKey}</div>
        <div className={`${cn.copySuccces} ${copyIsSuccess ? cn.visible : ''}`}>
          Copied
        </div>
      </button>
      <div className={sharedStyles.authButtons}>
        <ButtonPrimary
          text="Sign In"
          onClick={() => {
            navigate(ROUTES.LOGIN_VERIFY_TWO_FACTOR);
            dispatch(setTotpNotActive());
          }}
          bold
        />
        <ButtonPseudo
          className={sharedStyles.backButton}
          text="Back"
          onClick={() => {
            navigate(ROUTES.LOGIN_EMAIL);
            dispatch(clearMfa());
          }}
          bold
        />
      </div>
    </div>
  );
};

export default SetupTwoFactorForm;
